require('../../modules/es.array.is-array');
var path = require('../../internals/path');

module.exports = path.Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/is-array.js
// module id = 540
// module chunks = 0 1